module.exports = __webpack_public_path__ + "static/pastor-mental-health-10f2f3cacaf6f214c026bb9eb2701bf5.jpg";